import { SketchElement } from '../../../../../inspector'

export function findSketchElementFromUuid(
  sketchSceneRootElement: SketchElement | null,
  uuid: string
): SketchElement | null {
  if (!sketchSceneRootElement) {
    return null
  }

  function searchElement(element: SketchElement): SketchElement | null {
    // Check if current element matches the UUID
    if (element.elementUUID === uuid) {
      return element
    }

    // Recursively search in children
    for (const child of element.children) {
      const found = searchElement(child)
      if (found) {
        return found
      }
    }

    return null
  }

  return searchElement(sketchSceneRootElement)
}
